import * as Icons from '@mui/icons-material'
import { IconProps, SvgIconProps } from '@mui/material'
import React from 'react'

import * as CustomIcons from './Custom'

const HEX_COLOR_REGEX = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3}|[A-Fa-f0-9]{8}|[A-Fa-f0-9]{4})$/

type IconComponent = React.ComponentType<SvgIconProps>

type IconLibrary = Record<string, IconComponent>

type CustomMuiProps = Pick<SvgIconProps, 'id' | 'key' | 'onClick' | 'onMouseOver' | 'fontSize'>

type Props = {
  iconName: string
  color?: IconProps['color'] | string
} & CustomMuiProps

export function IconSelector(props: Props) {
  const { iconName, color, ...rest } = props
  const IconComponent = (Icons as IconLibrary)[iconName] ?? (CustomIcons as IconLibrary)[iconName]

  const isHexColor = !!color && HEX_COLOR_REGEX.test(color)

  const colorProps = isHexColor ? { htmlColor: color } : { color: color as IconProps['color'] }

  return <>{IconComponent && <IconComponent {...rest} {...colorProps} />}</>
}
